import i18n from "i18next";

import type { Language } from "types";

export function translateLanguage(language: Language): string {
  const keyMap: Record<Language, string> = {
    en: i18n.t("common.locales.en"),
    sv: i18n.t("common.locales.sv"),
  };

  return keyMap[language] || "";
}
